module.exports = __webpack_public_path__ + "static/media/FacebookIconResp.c238d89b.svg";